var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('gmap-map',{ref:"mapRef",staticClass:"w-full h-540",attrs:{"zoom":12,"center":_vm.locationPin}},[_c('gmap-marker',{ref:"myMarker",attrs:{"position":_vm.locationPin}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }